<template>
    <v-content>
        <v-row>
            <v-col xs="10" sm="10" md="10" lg="4" xl="4"><h1>Asset Overview of {{ asset.name }}</h1></v-col>
            <v-col xs="1" sm="1" md="1"  lg="2" xl="2">
                <button class="btn-tool" @click="fundamentalEvent"> Fundamental </button>
            </v-col>
            <v-col xs="1" sm="1" md="1"  lg="2" xl="2">
                <button class="btn-tool" @click="technicalEvent"> Technical </button>
            </v-col>
            <v-col lg="4" xl="4"></v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <FundamentalOverview v-if="fundamental"/>
        <TechnicalOverview v-else/>
    </v-content>
</template>

<script>
    import Axios from 'axios';
    import FundamentalOverview from "./Fundamental/FundamentalOverview";
    import TechnicalOverview from "./Technical/TechnicalOverview";

    export default {
        name: "Symbol",
        components: {
            TechnicalOverview,
            FundamentalOverview
        },
        data() {
            return {
                fundamental: true
            };
        },
        props:{
            asset: Object
        },
        methods: {
            fundamentalEvent() {
                this.fundamental = true;
                Axios.get(`${this.$store.state.backend}/fundamentalOverview?assetTicker=${this.asset.ticker}`)
                    .then((response)=>{
                        // eslint-disable-next-line no-console
                        console.log(response);
                    });
            },
            technicalEvent() {
                this.fundamental = false;
                Axios.get(`${this.$store.state.backend}/technicalOverview?assetTicker=${this.asset.ticker}`)
                    .then((response)=>{
                        // eslint-disable-next-line no-console
                        console.log(response);
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../global";

    .btn-tool {
        background-color: rgb(0, 0, 0, 0);
        border-bottom: solid 2px $black-color;
        border-top: 0 !important;
        border-right: 0 !important;
        border-left: 0 !important;
        padding: 2% 7%;
        border-radius: 0;
    }
    .btn-tool:hover {
        border-bottom: solid 2px $primary-color !important;
        background-color: rgb(0,0,0,0) !important;
        color: $black-color !important;
    }
</style>


